"use client";

import { useEffect, useState } from "react";

/**
 * Returns true when view transitions should be active. The only condition
 * is that the browser supports `document.startViewTransition` — page
 * transitions are core to the Owlet experience, not an experiment, so
 * there is no Statsig kill switch.
 *
 * Hook is safe to call from any client component; on the server it returns
 * false (no SSR effect), avoiding hydration mismatch by gating the
 * feature-detect on an effect.
 */
export default function useViewTransitionsEnabled(): boolean {
  const [supported, setSupported] = useState(false);

  useEffect(() => {
    setSupported(
      typeof document !== "undefined" &&
        typeof document.startViewTransition === "function"
    );
  }, []);

  return supported;
}
